module.exports = __webpack_public_path__ + "cd455783/img/verified-icon.f93bbc14.svg";